import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface AuthDialogProps {
  open: boolean;
}

const AuthDialog = ({ open }: AuthDialogProps) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open}>
      <DialogTitle>Увійти в аккаунт</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Увійдіть або зареєструйтесь для отримання повністю готового проєкту
          під ключ.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => navigate('/login')}>Увійти</Button>
        <Button onClick={() => navigate('/register')}>Зареєструватися</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthDialog;
